document.addEventListener("DOMContentLoaded", function () {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        entry.target.classList.add("in-view");
      }
    });
  });

  const fadeInContent = document.querySelectorAll(".fade-in-on-scroll");

  if (fadeInContent.length) {
    fadeInContent.forEach(function (fadeInBlock) {
      observer.observe(fadeInBlock);
    });
  }
});
